import { useMemo } from 'react';

export default function useBase64Decoded(base64Str: string): string {
  return useMemo(() => {
    try {
      return window.atob(base64Str);
    } catch (error) {
      console.error(error);
      return '';
    }
  }, [base64Str]);
}
